import { useState, useEffect, useCallback } from "react";
import { useAppContext } from "../context/AppContext";
import { ProductServices } from "../Firebase/Services/product.services";
import { QueryDocumentSnapshot, DocumentData } from "firebase/firestore";

export const useFetchProducts = () => {
  const { products, setProducts } = useAppContext();

  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [page, setPage] = useState(1);
  const [lastDoc, setLastDoc] = useState<
    QueryDocumentSnapshot<DocumentData> | undefined
  >(undefined);

  const fetchProducts = useCallback(async () => {
    if (!hasMore || loading) return;

    try {
      setLoading(true);
      const res = await ProductServices.getProducts(page, lastDoc);
      const newProductList = (() => {
        const newProducts =
          page === 1
            ? res.productList
            : [...(products || []), ...res.productList];
        return newProducts;
      })();

      setProducts(newProductList);
      setHasMore(res.hasNextPage);

      if (res.productList.length !== 0) {
        setLastDoc(res.lastDoc);
      }
    } catch (error) {
      console.error("Error fetching products:", error);
    } finally {
      setLoading(false);
    }
  }, [hasMore, loading, page, lastDoc, setProducts, products]);

  const loadMore = () => {
    if (hasMore && !loading) {
      setPage((prev) => prev + 1);
    }
  };

  useEffect(() => {
    fetchProducts();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page]);

  return { loading, hasMore, loadMore, fetchProducts };
};
